import { Button, Col, Form, Input } from "antd";
import { StyledUserProfileGroupBtn } from "../../index.styled";
import AppRowContainer from "@lib/components/AppComponents/AppRowContainer";
import { useIntl } from "react-intl";
import { useMemo } from "react";
import { Manager } from "@lib/types/Manager";
import { passwordChangeSchema as yupSchema } from "@lib/schemas/auth";
import { createYupSync } from "@lib/helpers/TableHelper";
import { useManagerQueries } from "@lib/apiQueries";
import { useTypedSelector } from "@lib/redux";
import { AppCard } from "@lib/components/AppComponents";
import { MyProfileTabProps } from "..";

const MyPasswordChange = ({ query, loading }: MyProfileTabProps) => {
  const { messages } = useIntl();
  const [form] = Form.useForm();
  const password = Form.useWatch("password", form);
  const apiData = useMemo(() => query?.data?.data, [query?.data]);
  const { user } = useTypedSelector((state) => state.auth);

  const { updateManagerMutation } = useManagerQueries({
    id: user?.id,
    messages,
    enabled: !!user?.id,
  });

  const handleSubmit = async (values: Partial<Manager>) => {
    await updateManagerMutation.mutateAsync({
      ...apiData,
      password: values.password,
    });
    query.refetch();
  };

  return (
    <AppCard style={{ padding: "20px" }} loading={loading}>
      <Form form={form} onFinish={handleSubmit}>
        <AppRowContainer gutter={16}>
          <Col xs={24} md={12}>
            <Form.Item
              name="password"
              rules={[createYupSync({ schema: yupSchema })]}
            >
              <Input.Password placeholder="Enter new password" />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              name="passwordConfirmation"
              rules={[
                createYupSync({ schema: yupSchema, formData: { password } }),
              ]}
            >
              <Input.Password placeholder="Confirm new password" />
            </Form.Item>
          </Col>
          <Col xs={24} md={24}>
            <StyledUserProfileGroupBtn
              shouldUpdate
              className="user-profile-group-btn"
            >
              <Button
                type="primary"
                htmlType="submit"
                loading={updateManagerMutation.isPending}
                disabled={updateManagerMutation.isPending}
              >
                {messages["common.save"] as string}
              </Button>
            </StyledUserProfileGroupBtn>
          </Col>
        </AppRowContainer>
      </Form>
    </AppCard>
  );
};

export default MyPasswordChange;
